// site-footer.js — back-to-top button visibility + scroll behavior.
const SiteFooter = {
	onReady() {
		const button = document.querySelector('.ax-footer__to-top');
		if (!button) {
			return;
		}

		function updateVisibility() {
			button.classList.toggle('is-visible', window.scrollY > 600);
		}
		updateVisibility();
		window.addEventListener('scroll', updateVisibility, { passive: true });

		button.addEventListener('click', () => {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	},
};

export default SiteFooter;


